import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { useQuery } from '@apollo/client';

import { FETCH_USER_UPLIANCE_REVIEW } from '../app/graphql/queries';
import { userIdSelector } from '../app/main/mainSlice';
import { referralReviewSelector, setReferralReview } from '../app/recipeCreation/createRecipe.slice';
import { useAppSelector } from '../app/store/hooks';
import { ErrorManagementContext } from '../utils/errorManagement/ErrorManagementProvider';

const useFetchUplainceReview = (
    handleOnCompleted?: (reviewText: string | null) => void,  
    handleOnError?: () => void                              
) => {    const userId = useAppSelector(userIdSelector);
    const reviewText = useAppSelector(referralReviewSelector);
    const { cookClubLog } = useContext(ErrorManagementContext);
    const dispatch = useDispatch();

    // TODO 
    // Add santizer and onCompleted actions error handling
    const { data, loading } = useQuery(FETCH_USER_UPLIANCE_REVIEW, {
        variables: { user_id: userId },
        skip: !userId || !!reviewText,
        onCompleted: () => {
            if (handleOnCompleted)
                handleOnCompleted(data?.User_Upliance_Review[0]?.review_text)
            dispatch(setReferralReview(data?.User_Upliance_Review[0]?.review_text));
        },
        onError: (errorMessage) => {
            cookClubLog(
                "",
                "Unable to fetch Review!",
                '',
                { ui: { type: "error" }, browserConsole: true })
            console.error("Error occurred while fetching review:", errorMessage);
            if (handleOnError) handleOnError();
        }
    });

    const review = data?.User_Upliance_Review[0]?.review_text || reviewText;
    const photo = data?.User_Upliance_Review[0]?.review_image || null;

    return { review_text: review, review_image: photo, loading };
};

export default useFetchUplainceReview;
